module.exports = __webpack_public_path__ + "static/media/toss_grumley.c9a2216e.jpg";